/* Cayac Industrial — interacciones del tema (sin librerías) */

/* ── Índice local del catálogo ────────────────────────────────────────
   La búsqueda de Shopify no indexa el SKU, así que el tema arma su
   propio índice con /products.json (una vez por sesión) y busca en él
   por clave o por título. */
window.CayacIndex = (function () {
  var promise = null;
  function load() {
    if (promise) return promise;
    var cached = null;
    try { cached = sessionStorage.getItem('cayac-index'); } catch (e) {}
    if (cached) { promise = Promise.resolve(JSON.parse(cached)); return promise; }
    promise = fetch('/products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var list = (d.products || []).map(function (p) {
          var v = (p.variants || [])[0] || {};
          var img = (p.images || [])[0] || {};
          return {
            handle: p.handle,
            url: '/products/' + p.handle,
            title: p.title,
            vendor: v.sku || p.vendor || '',
            featured_image: { url: img.src || '' },
            variants: [{ sku: v.sku || '' }],
            haystack: ((p.variants || []).map(function (x) { return x.sku || ''; }).join(' ') + ' ' + p.title + ' ' + (p.vendor || '')).toLowerCase()
          };
        });
        try { sessionStorage.setItem('cayac-index', JSON.stringify(list)); } catch (e) {}
        return list;
      })
      .catch(function () { return []; });
    return promise;
  }
  return {
    search: function (term, limit) {
      var q = (term || '').trim().toLowerCase();
      if (!q) return Promise.resolve([]);
      return load().then(function (list) {
        return list.filter(function (p) { return p.haystack.indexOf(q) !== -1; }).slice(0, limit || 8);
      });
    }
  };
})();


/* menú móvil, buscador plegable, ± de cantidad */
document.addEventListener('click', function (e) {
  var t = e.target.closest('[data-toggle]');
  if (t) {
    var el = document.querySelector(t.getAttribute('data-toggle'));
    if (el) {
      var open = !el.classList.contains('is-open');
      el.classList.toggle('is-open', open);
      t.setAttribute('aria-expanded', open);
      if (el.id === 'cayac-nav') {
        var scrim = document.querySelector('.nav-scrim');
        if (scrim) { scrim.hidden = !open; scrim.classList.toggle('is-open', open); }
        document.body.style.overflow = open ? 'hidden' : '';
      }
    }
    return;
  }
  var faq = e.target.closest('.faq-head');
  if (faq) {
    var card = faq.closest('[data-faq]');
    var open = card.classList.toggle('is-open');
    faq.setAttribute('aria-expanded', open);
    return;
  }
  var step = e.target.closest('[data-qty]');
  if (step) {
    var input = step.parentElement.querySelector('input');
    var next = parseInt(input.value || '1', 10) + parseInt(step.getAttribute('data-qty'), 10);
    input.value = Math.max(parseInt(input.min || '1', 10), next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

/* Escape cierra el cajón de menú */
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  var nav = document.querySelector('#cayac-nav.is-open');
  if (!nav) return;
  nav.classList.remove('is-open');
  var scrim = document.querySelector('.nav-scrim');
  if (scrim) { scrim.hidden = true; scrim.classList.remove('is-open'); }
  document.body.style.overflow = '';
});

document.addEventListener('change', function (e) {
  if (e.target.matches('[data-auto-submit]')) e.target.closest('form').submit();
});

/* ── Búsqueda del encabezado ─────────────────────────────────────────
   Panel de sugerencias con foto, marca y título. Si además estás en la
   pantalla de resultados, la retícula se filtra en vivo al teclear. */
(function () {
  var MIN = 2, WAIT = 250, LIMIT = 6;
  var forms = document.querySelectorAll('form[data-predictive]');
  if (!forms.length) return;

  var root = document.querySelector('[data-search-root]');
  var gridCtl = null;

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function filterGrid(term) {
    if (!root) return;
    if (gridCtl) gridCtl.abort();
    gridCtl = new AbortController();
    root.classList.add('is-loading');
    fetch('/search?q=' + encodeURIComponent(term) + '&section_id=main', { signal: gridCtl.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-search-root]');
        if (next) root.innerHTML = next.innerHTML;
        root.classList.remove('is-loading');
        history.replaceState({}, '', term ? '/search?q=' + encodeURIComponent(term) : '/search');
      })
      .catch(function () { root.classList.remove('is-loading'); });
  }

  forms.forEach(function (form) {
    var input = form.querySelector('input[type=search]');
    var panel = form.querySelector('.ps-panel');
    var clear = form.querySelector('.ps-clear');
    if (!input || !panel) return;

    var timer = null, controller = null, index = -1;

    function close() {
      panel.hidden = true;
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      index = -1;
    }
    function items() { return panel.querySelectorAll('.ps-item'); }
    function mark(next) {
      var list = items();
      if (!list.length) return;
      if (index >= 0 && list[index]) list[index].removeAttribute('aria-selected');
      index = (next + list.length) % list.length;
      list[index].setAttribute('aria-selected', 'true');
    }
    function sync() { if (clear) clear.hidden = input.value.trim().length === 0; }

    function render(products, term) {
      if (!products.length) {
        panel.innerHTML = '<p class="ps-note">Sin resultados para “' + esc(term) + '”. Prueba con la clave del producto.</p>';
      } else {
        panel.innerHTML = products.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
          return '<a class="ps-item" href="' + p.url + '" role="option">'
            + '<span class="ps-thumb"' + (img ? ' style="background-image:url(' + img + ')"' : '') + '></span>'
            + '<span class="ps-txt">'
            + (function () {
                var v = (p.variants && p.variants[0]) || {};
                var code = v.sku || p.vendor || '';
                return code ? '<span class="ps-vendor">' + esc(code) + '</span>' : '';
              })()
            + '<span class="ps-title">' + esc(p.title) + '</span>'
            + '</span></a>';
        }).join('')
          + '<a class="ps-all" href="/search?q=' + encodeURIComponent(term) + '">Ver todos los resultados'
          + '<svg class="ic ic-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></a>';
      }
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      index = -1;
    }

    function suggest(term) {
      if (controller) controller.abort();
      controller = new AbortController();
      fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=' + LIMIT,
        { signal: controller.signal, headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) {
          var list = (d.resources && d.resources.results && d.resources.results.products) || [];
          return window.CayacIndex.search(term, LIMIT).then(function (local) {
            var seen = {};
            list.forEach(function (p) { seen[p.handle] = true; });
            local.forEach(function (p) { if (!seen[p.handle]) { seen[p.handle] = true; list.push(p); } });
            render(list.slice(0, LIMIT), term);
          });
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          window.CayacIndex.search(term, LIMIT).then(function (local) {
            if (local.length) { render(local, term); return; }
            panel.innerHTML = '<p class="ps-note">No se pudo consultar el catálogo. Pulsa Enter para buscar.</p>';
            panel.hidden = false;
          });
        });
    }

    sync();

    input.addEventListener('input', function () {
      var term = input.value.trim();
      sync();
      clearTimeout(timer);
      if (term.length < MIN) { close(); if (root) filterGrid(term); return; }
      timer = setTimeout(function () {
        suggest(term);
        if (root) filterGrid(term);
      }, WAIT);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); mark(index + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(index - 1); }
      else if (e.key === 'Enter' && index >= 0) {
        var sel = items()[index];
        if (sel) { e.preventDefault(); window.location.href = sel.getAttribute('href'); }
      }
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN && panel.innerHTML) {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    });

    if (clear) {
      clear.addEventListener('click', function () {
        input.value = '';
        sync();
        close();
        input.focus();
        if (root) filterGrid('');
      });
    }

    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  });
})();

/* ── Captura de partidas con predicción ───────────────────────────────
   En la pantalla de cotización: al escribir una clave o descripción se
   sugieren productos del catálogo; al elegir uno y pulsar Agregar
   partida entra al carrito con la cantidad indicada. Si el texto no
   coincide con ningún producto, se envía como partida libre en la nota
   del pedido para que ventas la cotice igual. */
(function () {
  var row = document.querySelector('[data-add-line]');
  if (!row) return;

  var input = row.querySelector('[data-add-query]');
  var qty = row.querySelector('[data-add-qty]');
  var button = row.querySelector('[data-add-submit]');
  var panel = row.querySelector('.ac-panel');
  var MIN = 2, WAIT = 250;
  var timer = null, controller = null, index = -1, picked = null;

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function close() { panel.hidden = true; panel.innerHTML = ''; index = -1; }
  function items() { return panel.querySelectorAll('.ac-item'); }
  function mark(next) {
    var list = items();
    if (!list.length) return;
    if (index >= 0 && list[index]) list[index].removeAttribute('aria-selected');
    index = (next + list.length) % list.length;
    list[index].setAttribute('aria-selected', 'true');
    list[index].scrollIntoViewIfNeeded ? list[index].scrollIntoViewIfNeeded() : null;
  }
  function busy(on, label) {
    button.disabled = on;
    button.style.opacity = on ? '.6' : '';
    if (label) button.textContent = label;
  }

  function render(products, term) {
    if (!products.length) {
      panel.innerHTML = '<p class="ac-note">Sin coincidencias para “' + esc(term)
        + '”. Puedes agregarla igual: se envía como partida libre.</p>';
    } else {
      panel.innerHTML = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
        var v = (p.variants && p.variants[0]) || {};
        var sku = v.sku || p.vendor || '';
        return '<button class="ac-item" type="button" role="option"'
          + ' data-handle="' + esc(p.handle) + '"'
          + ' data-label="' + esc((sku ? sku + ' · ' : '') + p.title) + '">'
          + '<span class="ac-thumb"' + (img ? ' style="background-image:url(' + img + ')"' : '') + '></span>'
          + '<span class="ac-txt">'
          + (sku ? '<span class="ac-sku">' + esc(sku) + '</span>' : '')
          + '<span class="ac-title">' + esc(p.title) + '</span>'
          + '</span></button>';
      }).join('');
    }
    panel.hidden = false;
    index = -1;
  }

  /* La API de sugerencias no indexa SKU. Cuando el término parece una
     clave (letras + dígitos, p. ej. BA040 o MO001) se consulta además
     /search con la sintaxis de campos, que sí busca en variants.sku, y
     se combinan los resultados sin repetir. */
  function looksLikeSku(term) {
    return /\d/.test(term) && term.length >= 3;
  }

  /* Índice local del catálogo: /products.json trae los productos con sus
     variantes (y por tanto el SKU), que la búsqueda de Shopify no indexa.
     Se pide una vez por sesión y se consulta en memoria. */
  var indexPromise = null;
  function catalogIndex() {
    if (indexPromise) return indexPromise;
    var cached = null;
    try { cached = sessionStorage.getItem('cayac-index'); } catch (e) {}
    if (cached) {
      indexPromise = Promise.resolve(JSON.parse(cached));
      return indexPromise;
    }
    indexPromise = fetch('/products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var list = (d.products || []).map(function (p) {
          var v = (p.variants || [])[0] || {};
          var img = (p.images || [])[0] || {};
          return {
            handle: p.handle,
            url: '/products/' + p.handle,
            title: p.title,
            vendor: v.sku || p.vendor || '',
            featured_image: { url: img.src || '' },
            variants: [{ sku: v.sku || '' }],
            skus: (p.variants || []).map(function (x) { return (x.sku || '').toLowerCase(); }).join(' ')
          };
        });
        try { sessionStorage.setItem('cayac-index', JSON.stringify(list)); } catch (e) {}
        return list;
      })
      .catch(function () { return []; });
    return indexPromise;
  }

  function bySkuLocal(term) { return window.CayacIndex.search(term, 8); }

  /* Respaldo: la página de resultados de Shopify. */
  function fromResultsPage(term) {
    return fetch('/search?q=' + encodeURIComponent(term) + '&type=product')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return [];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return [].slice.call(doc.querySelectorAll('.pcard')).map(function (card) {
          var link = card.querySelector('a[href]');
          var img = card.querySelector('img');
          var code = card.querySelector('.pcard-code');
          var title = card.querySelector('h3');
          return {
            handle: (link && link.getAttribute('href') || '').split('/').pop(),
            url: link ? link.getAttribute('href') : '#',
            title: title ? title.textContent.trim() : '',
            vendor: code ? code.textContent.trim() : '',
            featured_image: { url: img ? img.getAttribute('src') : '' },
            variants: [{ sku: code ? code.textContent.trim() : '' }]
          };
        }).filter(function (p) { return p.title; });
      })
      .catch(function () { return []; });
  }

  function bySku(term) {
    var q = 'variants.sku:*' + term + '* OR sku:*' + term + '*';
    return fetch('/search?q=' + encodeURIComponent(q) + '&type=product&view=cayac-json',
      { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('sin vista');
        return r.text();
      })
      .then(function (txt) {
        var d = JSON.parse(txt);
        var list = Array.isArray(d) ? d : (d.products || []);
        if (list.length) return list;
        throw new Error('vacío');
      })
      .catch(function () {
        return bySkuLocal(term).then(function (local) {
          return local.length ? local : fromResultsPage(term);
        });
      });
  }

  function suggest(term) {
    if (controller) controller.abort();
    controller = new AbortController();
    fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6',
      { signal: controller.signal, headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (d) {
        var list = (d.resources && d.resources.results && d.resources.results.products) || [];
        if (list.length && !looksLikeSku(term)) { render(list, term); return; }
        return bySku(term).then(function (extra) {
          var seen = {};
          list.forEach(function (p) { seen[p.handle] = true; });
          extra.forEach(function (p) { if (!seen[p.handle]) { seen[p.handle] = true; list.push(p); } });
          render(list.slice(0, 8), term);
        });
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        panel.innerHTML = '<p class="ac-note">No se pudo consultar el catálogo. Escribe la clave completa y pulsa Agregar partida: se envía igual.</p>';
        panel.hidden = false;
        index = -1;
      });
  }

  input.addEventListener('input', function () {
    picked = null;
    var term = input.value.trim();
    clearTimeout(timer);
    if (term.length < MIN) { close(); return; }
    timer = setTimeout(function () { suggest(term); }, WAIT);
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Enter') {
      e.preventDefault();
      var list = items();
      if (!panel.hidden && index >= 0 && list[index]) list[index].click();
      else button.click();
      return;
    }
    if (panel.hidden) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); mark(index + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); mark(index - 1); }
  });

  panel.addEventListener('click', function (e) {
    var pick = e.target.closest('.ac-item');
    if (!pick) return;
    picked = pick.getAttribute('data-handle');
    input.value = pick.getAttribute('data-label');
    close();
    qty.focus();
    qty.select();
  });

  document.addEventListener('click', function (e) {
    if (!row.contains(e.target)) close();
  });

  function addProduct(handle, amount) {
    busy(true, 'Agregando…');
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
        if (!v) throw new Error('sin variante');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: amount }] })
        });
      })
      .then(function () { window.location.reload(); })
      .catch(function () { busy(false, 'Agregar partida'); addFreeText(input.value.trim(), amount); });
  }

  function addFreeText(text, amount) {
    if (!text) return;
    busy(true, 'Agregando…');
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var prev = cart.note ? cart.note + '\n' : '';
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: prev + 'Partida libre: ' + text + ' — cantidad ' + amount })
        });
      })
      .then(function () { window.location.reload(); })
      .catch(function () { busy(false, 'Agregar partida'); });
  }

  button.addEventListener('click', function () {
    var amount = Math.min(1000, Math.max(1, parseInt(qty.value || '1', 10)));
    var term = input.value.trim();
    if (!term) { input.focus(); return; }
    if (picked) addProduct(picked, amount);
    else {
      // sin selección: intenta la primera coincidencia, y si no hay, partida libre
      fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=1',
        { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) {
          var list = (d.resources && d.resources.results && d.resources.results.products) || [];
          if (list.length) addProduct(list[0].handle, amount);
          else addFreeText(term, amount);
        })
        .catch(function () { addFreeText(term, amount); });
    }
  });
})();

/* Tras enviar la cotización, vacía el pedido para que la siguiente
   solicitud empiece limpia (una sola vez por confirmación). */
(function () {
  if (!document.querySelector('[data-quote-sent]')) return;
  if (sessionStorage.getItem('cayac-quote-cleared') === '1') return;
  fetch('/cart/clear.js', { method: 'POST' })
    .then(function () { sessionStorage.setItem('cayac-quote-cleared', '1'); })
    .catch(function () {});
})();

/* ── Cajón del pedido ─────────────────────────────────────────────────
   El botón del carrito abre un panel lateral con las partidas, el
   subtotal y el acceso a la cotización. Las cantidades se cambian sin
   salir del panel. Al agregar un producto desde el catálogo o la ficha,
   el cajón se abre solo. */
(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var body = drawer.querySelector('[data-drawer-body]');
  var totalEl = drawer.querySelector('[data-drawer-total]');
  var countEl = document.querySelector('[data-cart-count]');
  var CATALOG = '/collections/all';

  var drawerEl = document.getElementById('cart-drawer');
  var showPrices = !drawerEl || drawerEl.getAttribute('data-show-prices') !== '0';

  function money(cents) {
    if (!showPrices) return '';
    return '$ ' + Math.round(cents / 100).toLocaleString('es-MX');
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function paint(cart) {
    if (countEl) countEl.textContent = cart.item_count;
    if (totalEl) totalEl.textContent = money(cart.total_price);
    if (!cart.items.length) {
      body.innerHTML = '<div class="drawer-empty">'
        + '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.4 11.2a2 2 0 0 0 2 1.6h8.5a2 2 0 0 0 2-1.6L21.5 7H6"/></svg>'
        + '<p>Tu pedido está vacío.</p>'
        + '<a class="btn btn-secondary" href="' + CATALOG + '">Ver catálogo</a></div>';
      return;
    }
    body.innerHTML = cart.items.map(function (it, i) {
      return '<div class="dline" data-key="' + esc(it.key) + '">'
        + (it.sku ? '<p class="dline-sku">' + esc(it.sku) + '</p>' : '')
        + '<h3>' + esc(it.product_title) + '</h3>'
        + '<div class="dline-row"><div class="dline-qty">'
        + '<button type="button" data-line="' + (i + 1) + '" data-to="' + (it.quantity - 1) + '" aria-label="Quitar uno">'
        + '<svg class="ic ic-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M5 12h14"/></svg></button>'
        + '<span>' + it.quantity + '</span>'
        + '<button type="button" data-line="' + (i + 1) + '" data-to="' + (it.quantity + 1) + '" aria-label="Agregar uno">'
        + '<svg class="ic ic-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>'
        + '</div>' + (showPrices ? '<b class="dline-total">' + money(it.final_line_price) + '</b>' : '') + '</div></div>';
    }).join('');
  }

  function load() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(paint)
      .catch(function () { body.innerHTML = '<p class="drawer-loading">No se pudo cargar el pedido.</p>'; });
  }

  function open(added) {
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    load().then(function () { if (added) flash(); });
  }

  /* Aviso dentro del cajón al agregar un producto */
  function flash() {
    var prev = body.querySelector('.drawer-flash');
    if (prev) prev.remove();
    var note = document.createElement('p');
    note.className = 'drawer-flash';
    note.setAttribute('role', 'status');
    note.innerHTML = '<svg class="ic ic-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="m8.5 12.5 2.5 2.5 4.5-5"/></svg>Producto agregado';
    body.insertBefore(note, body.firstChild);
    body.scrollTop = 0;
    setTimeout(function () { note.remove(); }, 3200);
  }
  function close() {
    drawer.hidden = true;
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-drawer-close]')) { close(); return; }

    var step = e.target.closest('.dline-qty button');
    if (step) {
      var to = Math.max(0, parseInt(step.getAttribute('data-to'), 10));
      body.style.opacity = '.55';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(step.getAttribute('data-line'), 10), quantity: to })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { paint(cart); body.style.opacity = ''; })
        .catch(function () { body.style.opacity = ''; });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });

  /* Agregar al pedido sin salir de la página: los formularios de
     producto se envían por AJAX y abren el cajón. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var button = form.querySelector('button[type=submit]');
    if (button) { button.disabled = true; button.style.opacity = '.6'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { open(true); })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (button) { button.disabled = false; button.style.opacity = ''; }
      });
  });
})();

/* ── Carrusel de guías ────────────────────────────────────────────────
   Con más de tres notas, los botones desplazan una tarjeta por pulsación
   y se desactivan en los extremos. */
(function () {
  var rail = document.querySelector('[data-carousel].is-carousel');
  if (!rail) return;
  var prev = document.querySelector('[data-carousel-prev]');
  var next = document.querySelector('[data-carousel-next]');

  function step() {
    var card = rail.querySelector('.post');
    return card ? card.getBoundingClientRect().width + 18 : rail.clientWidth / 3;
  }
  function sync() {
    var max = rail.scrollWidth - rail.clientWidth - 2;
    if (prev) prev.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= max;
  }
  if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
  rail.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
})();

/* Encabezado fijo compacto: al desplazarse queda solo la fila del logo,
   el buscador y las acciones (la barra de avisos y la navegación se van).
   Publica su altura como --header-h para la columna de filtros. */
(function () {
  var header = document.querySelector('.header-sticky');
  if (!header) return;

  // El alto expandido se reserva en el contenedor: al plegarse, el
  // documento no se acorta, así el navegador no reajusta el scroll y no
  // se realimenta el umbral (era la causa del rebote infinito).
  // La altura perdida al plegar se devuelve con un espaciador después
  // del encabezado: el documento conserva su alto (nada de rebote) y el
  // contenedor sigue midiendo lo que su contenido, sin caja sobrante ni
  // sombra flotando debajo.
  var spacer = document.querySelector('.header-spacer');
  if (!spacer) {
    spacer = document.createElement('div');
    spacer.className = 'header-spacer';
    spacer.setAttribute('aria-hidden', 'true');
    header.parentNode.insertBefore(spacer, header.nextSibling);
  }

  var full = 0, shrink = 0, collapsedH = 0;
  function measure() {
    var was = header.classList.contains('is-stuck');
    spacer.style.height = '0px';
    if (was) header.classList.remove('is-stuck');
    full = header.offsetHeight;
    header.classList.add('is-stuck');
    var collapsed = header.offsetHeight;
    collapsedH = collapsed;
    if (!was) header.classList.remove('is-stuck');
    shrink = Math.max(0, full - collapsed);
    spacer.style.height = was ? shrink + 'px' : '0px';
    document.documentElement.style.setProperty('--header-h', full + 'px');
    document.documentElement.style.setProperty('--header-h-min', collapsed + 'px');
    document.documentElement.style.setProperty('--header-now', (header.classList.contains('is-stuck') ? collapsed : full) + 'px');
    // alto del título de sección: los chips se fijan justo debajo de él
    var chead = document.querySelector('.collection-head');
    if (chead) document.documentElement.style.setProperty('--chead-h', chead.offsetHeight + 'px');
  }

  var stuck = false, ticking = false, lockUntil = 0;
  function apply() {
    ticking = false;
    if (performance.now() < lockUntil) return;
    var y = window.scrollY || window.pageYOffset || 0;
    // Umbrales separados: entra pasando el alto reservado, sale bien arriba.
    if (!stuck && y > full + 40) {
      stuck = true;
      lockUntil = performance.now() + 500;
      header.classList.add('is-stuck');
      spacer.style.height = shrink + 'px';
      document.documentElement.style.setProperty('--header-now', collapsedH + 'px');
      window.scrollTo(0, y);
    } else if (stuck && y < 16) {
      stuck = false;
      lockUntil = performance.now() + 500;
      header.classList.remove('is-stuck');
      spacer.style.height = '0px';
      document.documentElement.style.setProperty('--header-now', full + 'px');
      window.scrollTo(0, y);
    }
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(apply);
  }

  // El encabezado cambia de alto al plegarse y, en móvil, el buscador
  // aparece o desaparece: se publica su alto real de forma continua para
  // que el título y los chips queden pegados sin hueco.
  function live() {
    var rect = header.getBoundingClientRect();
    var visible = Math.max(0, rect.bottom);
    document.documentElement.style.setProperty('--header-now', Math.round(Math.min(visible, rect.height)) + 'px');
    var chead = document.querySelector('.collection-head');
    if (chead) document.documentElement.style.setProperty('--chead-h', chead.offsetHeight + 'px');
  }
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(live);
    ro.observe(header);
    var inner = header.querySelector('.site-header');
    if (inner) ro.observe(inner);
  }
  window.addEventListener('transitionend', live);

  measure();
  live();
  apply();
  window.addEventListener('scroll', function () { live(); }, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { measure(); apply(); });
  window.addEventListener('load', function () { measure(); apply(); });
})();


/* ── Galería del producto ─────────────────────────────────────────────
   Las miniaturas cambian la imagen principal sin recargar, y al pulsar
   la imagen se abre el visor sobre la misma página (nunca una pestaña
   nueva). Escape o clic fuera cierra. */
(function () {
  var gallery = document.querySelector('[data-gallery]');
  var box = document.getElementById('lightbox');
  if (!gallery || !box) return;

  var main = gallery.querySelector('#pmain');
  var zoomImg = box.querySelector('[data-zoom-img]');
  var lastFocus = null;

  gallery.addEventListener('click', function (e) {
    var thumb = e.target.closest('.pthumb');
    if (thumb && main) {
      main.src = thumb.getAttribute('data-src');
      main.setAttribute('data-full', thumb.getAttribute('data-full'));
      var img = thumb.querySelector('img');
      if (img) main.alt = img.alt;
      gallery.querySelectorAll('.pthumb').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      return;
    }
    if (e.target.closest('[data-zoom-open]') && main) {
      lastFocus = document.activeElement;
      zoomImg.src = main.getAttribute('data-full') || main.src;
      zoomImg.alt = main.alt || '';
      box.hidden = false;
      document.body.style.overflow = 'hidden';
      box.querySelector('[data-zoom-close]').focus();
    }
  });

  function close() {
    box.hidden = true;
    zoomImg.removeAttribute('src');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  box.addEventListener('click', function (e) {
    if (e.target.closest('[data-zoom-close]') || e.target === box) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !box.hidden) close();
  });
})();

/* ── Carrusel de destacados: bucle infinito ───────────────────────────
   Las tarjetas se clonan hasta cubrir el doble del ancho visible, así
   siempre hay riel por delante; la que sale por la izquierda se recoloca
   al final en el mismo cuadro, sin esperas ni rebobinado. Se detiene con
   el cursor, el toque o el foco; las flechas desplazan con suavidad. */
(function () {
  function init(rail) {
    if (!rail || rail.dataset.autoplay === 'on') return;
    rail.dataset.autoplay = 'on';
    rail.style.scrollBehavior = 'auto';
    rail.style.scrollSnapType = 'none';

    var scope = rail.closest('.section') || document;
    var prevBtn = scope.querySelector('[data-carousel-prev]');
    var nextBtn = scope.querySelector('[data-carousel-next]');
    var hold = false, pos = rail.scrollLeft;

    ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach(function (e) {
      rail.addEventListener(e, function () { hold = true; }, { passive: true });
    });
    ['mouseleave', 'focusout', 'touchend', 'touchcancel'].forEach(function (e) {
      rail.addEventListener(e, function () { hold = false; }, { passive: true });
    });

    function gap() { return parseFloat(getComputedStyle(rail).columnGap || '14') || 14; }

    // Se clona el juego original hasta tener riel de sobra por delante.
    var originals = Array.prototype.slice.call(rail.children);
    function fill() {
      if (!originals.length) return;
      var guard = 0;
      while (rail.scrollWidth < rail.clientWidth * 2 + 200 && guard < 40) {
        originals.forEach(function (node) {
          var copy = node.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.querySelectorAll('a,button,iframe,input').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
          rail.appendChild(copy);
        });
        guard++;
      }
    }
    fill();
    window.addEventListener('resize', fill);

    // La tarjeta que sale se recoloca al final en el mismo cuadro.
    function recycle() {
      var g = gap(), guard = 0;
      while (rail.children.length > 1 && guard < 10) {
        var first = rail.firstElementChild;
        var w = first.offsetWidth + g;
        if (pos < w) break;
        rail.appendChild(first);
        pos -= w;
        rail.scrollLeft = pos;
        guard++;
      }
    }

    rail.addEventListener('scroll', function () {
      if (Math.abs(rail.scrollLeft - pos) > 2) pos = rail.scrollLeft;
    }, { passive: true });

    function step(dir) {
      var card = rail.querySelector('.feat-card');
      var amount = card ? card.offsetWidth + gap() : rail.clientWidth * 0.8;
      rail.style.scrollBehavior = 'smooth';
      rail.scrollBy({ left: dir * amount });
      setTimeout(function () {
        rail.style.scrollBehavior = 'auto';
        pos = rail.scrollLeft;
        if (dir < 0 && pos < 4) {
          // hacia atrás en el borde: se trae la última tarjeta al frente
          var g = gap(), last = rail.lastElementChild;
          if (last) { rail.insertBefore(last, rail.firstElementChild); pos += last.offsetWidth + g; rail.scrollLeft = pos; }
        }
        recycle();
      }, 420);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    var last = performance.now();
    function drift(now) {
      var dt = Math.min(now - last, 64);
      last = now;
      if (!hold && rail.scrollWidth > rail.clientWidth + 4) {
        pos += (26 * dt) / 1000;
        rail.scrollLeft = pos;
        recycle();
      }
      requestAnimationFrame(drift);
    }
    requestAnimationFrame(drift);
  }

  function boot() { document.querySelectorAll('.feat-rail').forEach(init); }
  boot();
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

/* ── Tira de filtros en móvil ─────────────────────────────────────────
   La tira se configura por JS con estilos en línea, de modo que funcione
   aunque una hoja en caché o del tema anterior imponga otras reglas.
   Solo toca los .chips de la columna de filtros; el resto del sitio no
   cambia. */
(function () {
  var MOBILE = 989;

  function setup(strip) {
    var on = window.innerWidth <= MOBILE;

    if (!on) {
      ['display','flexDirection','flexWrap','overflowX','overflowY','touchAction',
       'overscrollBehaviorX','webkitOverflowScrolling','width','maxWidth','minWidth',
       'scrollbarWidth','padding','margin','gap'].forEach(function (p) { strip.style[p] = ''; });
      Array.prototype.forEach.call(strip.children, function (c) { c.style.flex = ''; c.style.whiteSpace = ''; c.style.width = ''; });
      return;
    }

    strip.style.display = 'flex';
    strip.style.flexDirection = 'row';
    strip.style.flexWrap = 'nowrap';
    strip.style.gap = '8px';
    strip.style.width = '100%';
    strip.style.maxWidth = '100%';
    strip.style.minWidth = '0';
    strip.style.margin = '0';
    strip.style.padding = '2px 0 6px';
    strip.style.overflowX = 'auto';
    strip.style.overflowY = 'hidden';
    strip.style.touchAction = 'pan-x';
    strip.style.overscrollBehaviorX = 'contain';
    strip.style.webkitOverflowScrolling = 'touch';
    strip.style.scrollbarWidth = 'none';

    Array.prototype.forEach.call(strip.children, function (c) {
      c.style.flex = '0 0 auto';
      c.style.width = 'auto';
      c.style.whiteSpace = 'nowrap';
    });
  }

  function drag(strip) {
    if (strip.dataset.dragScroll === 'on') return;
    strip.dataset.dragScroll = 'on';
    var startX = 0, startLeft = 0, id = null, moved = 0;

    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      id = e.pointerId; startX = e.clientX; startLeft = strip.scrollLeft; moved = 0;
    });
    strip.addEventListener('pointermove', function (e) {
      if (id === null || e.pointerId !== id) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) < 4) return;
      moved = Math.abs(dx);
      strip.scrollLeft = startLeft - dx;
    }, { passive: true });
    function end(e) {
      if (id === null || (e && e.pointerId !== id)) return;
      id = null;
      if (moved > 8) {
        strip.addEventListener('click', function once(ev) {
          ev.preventDefault(); ev.stopPropagation();
          strip.removeEventListener('click', once, true);
        }, true);
      }
      moved = 0;
    }
    ['pointerup','pointercancel','pointerleave'].forEach(function (ev) { strip.addEventListener(ev, end); });

    strip.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      if (strip.scrollWidth <= strip.clientWidth) return;
      strip.scrollLeft += e.deltaY;
      e.preventDefault();
    }, { passive: false });
  }

  function contain() {
    var on = window.innerWidth <= MOBILE;
    var body = document.body, html = document.documentElement;
    [html, body].forEach(function (el) {
      el.style.overflowX = on ? 'hidden' : '';
      el.style.maxWidth = on ? '100%' : '';
    });
    document.querySelectorAll('.collection-body,.facets,.collection-results').forEach(function (el) {
      el.style.minWidth = on ? '0' : '';
      if (el.classList.contains('facets')) {
        el.style.maxWidth = on ? '100%' : '';
        el.style.boxSizing = on ? 'border-box' : '';
      }
    });
  }

  function boot() {
    var strips = document.querySelectorAll('.facets .chips');
    if (!strips.length) return;
    contain();
    strips.forEach(function (strip) {
      setup(strip);
      drag(strip);
    });
  }

  boot();
  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('resize', boot);
  document.addEventListener('shopify:section:load', boot);
})();
